/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Edit from './Edit/index'
import React from 'react'
import Read from './Read/index'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment/Appointment"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Read'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Read'}>
<Read
  viewPath={`${viewPath}/Read`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Edit'}>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}